module.exports = __webpack_public_path__ + "static/media/tools-text.8b5b4d66.svg";